import styled from '@emotion/styled';
import { Skeleton } from '@mui/material';
import { RATIOS, TILE_SPACING } from '../constants';
import { TEMPLATE_WIDTH } from './TemplateTile';

export const TemplateSkeleton = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
`;

export const ImageSkeleton = styled(Skeleton, {
    shouldForwardProp: prop => prop !== '$aspectRatio',
})<{ $aspectRatio: number }>`
    width: 100%;
    height: ${({ $aspectRatio }) => `${TEMPLATE_WIDTH / $aspectRatio}px`};
    border-radius: 8px;
    transform: none;
`;

export const TitleSkeleton = styled(Skeleton)`
    width: 30%;
    height: 12.5px;
    transform: none;
    border-radius: 7px;
`;

export interface SkeletonTemplate {
    aspectRatio: number;
}

export const SkeletonTemplate = ({ aspectRatio }: SkeletonTemplate) => (
    <TemplateSkeleton>
        <ImageSkeleton variant="rectangular" $aspectRatio={aspectRatio} />
        <TitleSkeleton variant="text" />
    </TemplateSkeleton>
);

export const generateSkeletonPhotos = () => {
    const aspectRatios = Object.values(RATIOS);
    return Array.from({ length: 3 }, (_, i) => {
        const aspectRatio = aspectRatios[i % aspectRatios.length];
        const imageHeight = TEMPLATE_WIDTH / aspectRatio;

        return {
            key: `skeleton-${i}`,
            id: `skeleton-${i}`,
            src: '',
            width: TEMPLATE_WIDTH,
            height: imageHeight + TILE_SPACING.BOTTOM_PADDING + TILE_SPACING.TITLE_MARGIN_TOP,
            imageHeight,
            aspectRatio,
            isSkeleton: true,
        };
    });
};
